export default "__VITE_ASSET__CIsDMxjS__"